/********************************************************* {COPYRIGHT-TOP} ***
 * Licensed Materials - Property of IBM
 *
 * (C) Copyright IBM Corporation 2016, 2024
 *
 * All Rights Reserved.
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 ********************************************************** {COPYRIGHT-END} **/

import React from 'react';
import PropTypes from 'prop-types';
import { Link, DefinitionTooltip } from '@carbon/react';
import classNames from 'classnames';
import { generateRandomTag } from '../utils/common';
import Markdown from './Markdown';

import { getTranslatedExtensions } from '../utils/translate';

const OperationTag = ({ tag, apiTags, markupType }) => {
  const tooltiptext = (tag, apiTags, markupType) => (
    <div>
      {apiTags.tags[tag].description && (
        <Markdown className="tagDescription" data={getTranslatedExtensions(apiTags.tags[tag], 'description')} markupType={markupType} />
      )}
      {apiTags.tags[tag].externalDocs && apiTags.tags[tag].externalDocs.description && (
        <div className={classNames('tagtip', 'cds--tooltip__footer')}>
          <Link href={apiTags.tags[tag].externalDocs.url} target="_blank" rel="noopener noreferrer">
            {apiTags.tags[tag].externalDocs.description + ': '}
            {apiTags.tags[tag].externalDocs.url}
          </Link>
        </div>
      )}
    </div>
  );

  let oaiTag;
  if (tag in apiTags.tags && ('description' in apiTags.tags[tag] || 'externalDocs' in apiTags.tags[tag])) {
    oaiTag = (
      <div className={classNames('cds--tag', generateRandomTag(tag))} data-floating-menu-container style={{ position: 'relative', float: 'right' }}>
        <DefinitionTooltip
          triggerClassName={generateRandomTag(tag)}
          tabIndex={0}
          direction="bottom"
          align="left"
          definition={tooltiptext(tag, apiTags, markupType)}
        >
          {tag}
        </DefinitionTooltip>
      </div>
    );
  } else {
    oaiTag = (
      <span className={classNames('cds--tag', generateRandomTag(tag))} style={{ position: 'relative', float: 'right' }}>
        {tag}
      </span>
    );
  }

  return oaiTag;
};

OperationTag.propTypes = {
  tag: PropTypes.string,
  apiTags: PropTypes.object,
  markupType: PropTypes.string
};

export default OperationTag;
